<template lang="pug">
  div
    .col-md-12.p-0
      .form-group
        label.form-label {{ $t("components.home_care_time_slots.when") }}
        .btn-wrapper
          button(class="btn btn-outline btn-sm btn-today" @click.prevent="hide_time_slots")
            span {{ $t("components.home_care_time_slots.today") }}

          button(class="btn btn-outline btn-sm btn-other-day" @click.prevent="show_time_slots")
            span {{ $t("components.home_care_time_slots.other_day") }}

          button(class="btn btn-outline btn-sm btn-without-preference active" @click.prevent="show_nothing")
            span {{ $t("components.home_care_time_slots.without_preference") }}

    .col-md-12.p-0(v-if="today")
      input(type='hidden' name="appointment_request[time_slots_attributes][-1][date]" :value="today_date")
      input(type='hidden' name="appointment_request[time_slots_attributes][-1][period]" :value="period")
    div(v-else-if="today == null")
    div(v-else)
      br
      time-slot-list(:periods="periods" :availabilities="availabilities")
</template>

<script>
  import TimeSlotList from '@appComponents/TimeSlotList'
  import vSelect from 'vue-select'

  export default {
    components: {
      TimeSlotList,
      vSelect
    },
    props: {
      periods: Array,
      availabilities: {
        type: Array,
        default () {
          return [{
            id: 1,
            attributes: {
              date: undefined,
              period: 'all_day',
              _destroy: false
            }
          }]
        }
      }
    },
    data () {
      return {
        today: null,
        today_date: null,
        period: null,
        selectedPeriod: {
          label: this.$t('components.time_slot.periods.' + this.period),
          value: this.period
        }
      }
    },
    computed: {
      periodsTranslated () {
        var translatedPeriods = []
        for (var key in this.periods) {
          translatedPeriods.push(
            {
              label: this.$t('components.time_slot.periods.' + this.periods[key]),
              value: this.periods[key]
            }
          )
        }
        return translatedPeriods
      }
    },
    watch: {
      today () {
        this.$emit("change", {date: this.today_date, period: this.period})
      }
    },
    methods: {
      hide_time_slots () {
        this.today_date = new Date().toDateString()
        this.period = this.availabilities[0].attributes.period
        this.today = true
        $(".btn-today").addClass("active")
        $(".btn-other-day").removeClass("active")
        $(".btn-without-preference").removeClass("active")
      },

      show_time_slots () {
        this.today = false
        $(".btn-today").removeClass("active")
        $(".btn-other-day").addClass("active")
        $(".btn-without-preference").removeClass("active")
      },

      show_nothing () {
        this.today_date = null
        this.period = null
        this.today = null
        $(".btn-today").removeClass("active")
        $(".btn-other-day").removeClass("active")
        $(".btn-without-preference").addClass("active")
      }
    },
    mounted () {
      this.selectedPeriod["label"] = this.$t('components.time_slot.periods.' + this.period)
      this.selectedPeriod["value"] = this.period
    }
  }
</script>
